import React from 'react';

import { formatDateTime } from '../utils/format';

const TONE = {
  reception_completed: 'warning',
  ready_for_reporting: 'info',
  in_progress: 'brand',
  technical_review: 'review',
  revision_requested: 'danger',
  report_completed: 'success',
  closed: 'muted',
};

const LABEL = {
  reception_completed: 'پذیرش انجام شد',
  ready_for_reporting: 'آماده گزارش‌نویسی',
  in_progress: 'در دست ادیتور',
  technical_review: 'در انتظار تأیید فنی',
  revision_requested: 'نیازمند اصلاح',
  report_completed: 'تأیید شد — آماده تحویل',
  closed: 'تحویل شد',
};

export default function StatusBadge({ status, label }) {
  return (
    <span className={`badge badge--${TONE[status] || 'muted'}`}>
      {label || LABEL[status] || status}
    </span>
  );
}

/*
 * نشان فوریت.
 *
 * عمداً رنگ وضعیت نیست: فوریت و وضعیت دو چیز مستقل‌اند و اگر هر دو از یک
 * کانال بصری استفاده کنند، یکی دیگری را می‌پوشاند. وضعیت با نشان رنگی
 * می‌آید، فوریت با این برچسب و نوار راه‌راه بالای کارت.
 */
export function UrgentPill() {
  return (
    <span className="urgent-pill" title="به درخواست پزشک، خارج از نوبت رسیدگی شود">
      ⚡ فوری
    </span>
  );
}

/** نشان‌های بالای کارت — فوریت بالای وضعیت می‌نشیند. */
export function CardBadges({ item }) {
  return (
    <div className="card__badges">
      {item.is_urgent && <UrgentPill />}
      <StatusBadge status={item.status} label={item.status_display} />
    </div>
  );
}

/**
 * زمان پذیرش روی کارت.
 *
 * تصویربردار و ادیتور باید بتوانند تقدم و تأخر پرونده‌ها را تشخیص دهند؛ پیش
 * از این فقط ساعت دیده می‌شد (بدون تاریخ) و در میز ادیتور اصلاً چیزی نبود.
 *
 * عمداً «۳ ساعت پیش» نمی‌نویسیم: صفحه ممکن است ساعت‌ها باز بماند و آن عدد
 * بی‌آنکه کسی بفهمد کهنه می‌شود — دقیقاً در همان قضاوتی که این برچسب قرار
 * است کمکش کند. تاریخ و ساعت مطلق هیچ‌وقت کهنه نمی‌شود.
 */
export function ReceptionStamp({ at }) {
  if (!at) return null;
  return (
    <span className="card__stamp card__stamp--received">
      پذیرش <time>{formatDateTime(at)}</time>
    </span>
  );
}

export function EditTypeChip({ code, name }) {
  return (
    <span className="chip" title={name}>
      <span className="chip__code num">{code}</span>
      <bdi>{name}</bdi>
    </span>
  );
}
